// These pages look the same as a regular family page, but aren't a taxonomy in Kontent so we can't filter by there
export const overviewPages = ['overview', 'womens-watches', 'mens-watches', 'golden-watches']

const filterOptions = {
  overview: {
    title: 'Overview',
    sizes: ['large', 'medium', 'small'],
    materials: ['oystersteel', 'oystersteel-and-gold', 'gold', 'platinum'],
    dials: ['dark', 'coloured', 'light', 'gem-set', 'diamond-paved']
  },
  'womens-watches': {
    title: "Women's watches",
    sizes: ['large', 'medium', 'small'],
    materials: ['oystersteel', 'oystersteel-and-gold', 'gold', 'platinum'],
    dials: ['dark', 'coloured', 'light', 'gem-set', 'diamond-paved'],
    fixed: {
      style: ['women']
    }
  },
  'mens-watches': {
    title: "Mens's watches",
    sizes: ['large', 'medium', 'small'],
    materials: ['oystersteel', 'oystersteel-and-gold', 'gold', 'platinum'],
    dials: ['dark', 'coloured', 'light', 'gem-set', 'diamond-paved'],
    fixed: {
      style: ['men']
    }
  },
  'golden-watches': {
    title: 'Gold watches',
    styles: ['men', 'women'],
    sizes: ['large', 'medium', 'small'],
    dials: ['dark', 'coloured', 'light', 'gem-set', 'diamond-paved'],
    fixed: {
      material: ['gold']
    }
  },
  submariner: {
    title: 'Submariner',
    materials: ['oystersteel', 'oystersteel-and-gold', 'gold'],
    dials: ['dark', 'coloured']
  },
  'oyster-perpetual': {
    title: 'Oyster Perpetual',
    styles: ['men', 'women'],
    sizes: ['large', 'medium', 'small'],
    dials: ['dark', 'coloured', 'light']
  },
  datejust: {
    title: 'Datejust',
    sizes: ['large', 'medium', 'small'],
    materials: ['oystersteel', 'oystersteel-and-gold', 'gold'],
    dials: ['dark', 'coloured', 'light', 'gem-set', 'diamond-paved']
  },
  'lady-datejust': {
    title: 'Lady-Datejust',
    materials: ['oystersteel', 'oystersteel-and-gold', 'gold', 'platinum'],
    dials: ['dark', 'coloured', 'light', 'gem-set', 'diamond-paved']
  },
  milgauss: {
    title: 'Milgauss',
    dials: ['dark', 'coloured']
  },
  'cosmograph-daytona': {
    title: 'Cosmograph Daytona',
    materials: ['oystersteel', 'oystersteel-and-gold', 'gold', 'platinum'],
    dials: ['dark', 'coloured', 'light', 'gem-set']
  },
  'yacht-master': {
    title: 'Yacht-Master',
    styles: ['men', 'women'],
    sizes: ['large', 'medium'],
    materials: ['oystersteel', 'oystersteel-and-gold', 'gold', 'platinum'],
    dials: ['dark', 'coloured', 'light', 'diamond-paved']
  },
  'gmt-master-ii': {
    title: 'GMT-Master-II',
    materials: ['oystersteel', 'oystersteel-and-gold', 'gold'],
    dials: ['dark', 'coloured', 'light']
  },
  'air-king': {
    title: 'Air-King'
  },
  'day-date': {
    title: 'Day-Date',
    styles: ['men', 'women'],
    sizes: ['large', 'medium'],
    materials: ['gold', 'platinum'],
    dials: ['dark', 'coloured', 'light', 'gem-set', 'diamond-paved']
  },
  'sea-dweller': {
    title: 'Sea-Dweller',
    materials: ['oystersteel', 'oystersteel-and-gold'],
    dials: ['dark', 'coloured']
  },
  explorer: {
    title: 'Explorer',
    dials: ['dark', 'light']
  },
  'sky-dweller': {
    title: 'Sky-Dweller',
    materials: ['oystersteel', 'oystersteel-and-gold', 'gold'],
    dials: ['dark', 'coloured', 'light']
  },
  cellini: {
    title: 'Cellini',
    dials: ['dark', 'coloured', 'light']
  },
  pearlmaster: {
    title: 'Pearlmaster'
  }
}

export default filterOptions
